<div>
  <table matSort (matSortChange)="sortData($event)" [id]="tourId.wfQueueMgr.wfQueTable.wfQueueDetail.id" mat-table
    [dataSource]="_dataSource" multiTemplateDataRows class="mat-elevation-z8"
    [class.dynamic-execution-table]="hasCustomColumns">
    <ng-container matColumnDef="{{column.key}}" *ngFor="let column of colMgr.columns;let i=index;">
      <ng-container *ngIf="column.key === 'refresh'; else dataColumn">
        <th *matHeaderCellDef mat-header-cell class="refresh-header" [class.refresh-column]="hasCustomColumns">
          <button mat-icon-button type="button" class="refresh" [attr.aria-label]="refreshTooltip"
         (click)="refreshDynamicExecutionDetails()" [matTooltip]="refreshTooltip">
            <mat-icon>refresh</mat-icon>
          </button>
        </th>
      </ng-container>

      <ng-template #dataColumn>
      <div *ngIf="column.sortable; else unsortedHeader;">
        <th *matHeaderCellDef mat-header-cell [mat-sort-header]="column.key"
          [arrowPosition]="column.style.all?.['justify-content'] == 'right' ? 'before' : 'after'"
          [ngStyle]="column.style['header'] || column.style.all"
          [class]="hasCustomColumns ? column.key + '-column' : ''" appColumnResize>
          {{column.header}}
        </th>
      </div>

      <ng-template #unsortedHeader>
        <th *matHeaderCellDef mat-header-cell [ngStyle]="column.style['header'] || column.style.all"
          [class]="hasCustomColumns ? column.key + '-column' : ''">
          {{column.header}}
        </th>
      </ng-template>
      </ng-template>

      <td class="data-row" mat-cell *matCellDef="let element"
        [class]="hasCustomColumns ? 'data-row ' + column.key + '-column' : 'data-row'">
        <div class="cellHeight" [class.build-cell]="column.key === 'buildUrl'" [ngSwitch]="column.key" [ngStyle]="column.style.all">

          <!--Repo name column-->
          <div *ngSwitchCase="'repoName'" class="repoName" fxLayout="row" fxLayoutAlign="center" fxLayoutGap="6">
            <mat-icon (click)="cf.openInNewTab(element); $event.stopPropagation()" class="openInNew cursor"
              matTooltip="{{element?.actionUrl  ? openInNewIcon : titleService.noURLFound}}">open_in_new</mat-icon>
            <span [matTooltip]="element.repoName" class="ellipses"  [style.max-width.px]="wfQueueService.maxWidth">{{element.repoName}}</span>
          </div>

          <div *ngSwitchCase="'workflowName'" class="dynamic-name-cell" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="6">
            <span class="action-url-icon" [matTooltip]="element?.actionUrl ? openInNewIcon : titleService.noURLFound">
              <mat-icon class="openInNew cursor" [class.disabled-cursor]="!element?.actionUrl"
                [class.no-action-url]="!element?.actionUrl"
                (click)="element?.actionUrl && cf.openInNewTab(element); $event.stopPropagation()">open_in_new</mat-icon>
            </span>
            <span [matTooltip]="element.workflowName" class="ellipses">{{ element.workflowName }}</span>
          </div>

          <div *ngSwitchCase="'nodeName'" class="dynamic-name-cell ellipses" [matTooltip]="element.nodeName">{{ element.nodeName }}</div>

          <!--build column (scheduler)-->
          <div *ngSwitchCase="'buildUrl'">
            <a *ngIf="element?.buildUrl; else noBuild" class="build-action-label" [href]="element.buildUrl" target="_blank" rel="noopener"
              matTooltip="View builds triggered by this run" (click)="$event.stopPropagation()">View</a>
            <ng-template #noBuild><span class="build-action-label" matTooltip="No builds were triggered by this run">—</span></ng-template>
          </div>

          <div *ngSwitchCase="'cancelRun'"
            matTooltip="{{!authService.permissions['cancel-scheduler'] ? cf.messages.permissionMsg : ''}}"
            [ngClass]="{'disabled-cursor': !authService.permissions['cancel-scheduler'] || !element.canCancelRun || cancellingJobId !== null}">
            <button mat-stroked-button type="button" class="cancel-run-btn"
              [disabled]="!authService.permissions['cancel-scheduler'] || !element.canCancelRun || cancellingJobId !== null"
              matTooltip="Cancel this scheduled run"
              (click)="cancelRunClick.emit(element); $event.stopPropagation()">
              <mat-spinner *ngIf="cancellingJobId === element.jobId" [diameter]="16" color="warn"></mat-spinner>
              <span *ngIf="cancellingJobId !== element.jobId">Cancel</span>
            </button>
          </div>

          <!--type column-->
          <div *ngSwitchCase="'type'" [matTooltip]="element.type">
            {{element.type}}
          </div>

          <!-- status column -->
          <div *ngSwitchCase="'status'" [appStatus]="statusClass(element.status)" [width]="'8.5rem'"
            [padding]="hasCustomColumns ? '3px 8px' : undefined" [noWrap]="hasCustomColumns" [matTooltip]="element.status">
            {{ element.status.toLowerCase() === 'inprogress' ? cf.formatString(element.status) : element.status |
            titlecase }}
          </div>

          <div *ngSwitchCase="'conclusion'" [appStatus]="statusClass(element.conclusion)" [width]="'8.5rem'"
            [padding]="hasCustomColumns ? '3px 8px' : undefined" [noWrap]="hasCustomColumns" [matTooltip]="element.conclusion || 'N/A'">
            {{ element.conclusion ? (element.conclusion | titlecase) : 'N/A' }}
          </div>

          <div *ngSwitchCase="'dynamicAction'">
            <span class="redispatch-wrapper"
              [class.redispatch-disabled]="!authService.permissions['redispatch-dynamic-config'] || dynamicActionLoadingJobId === element.jobId || !isDynamicTriggerAllowed(element.status, element.conclusion)"
              [matTooltip]="authService.permissions['redispatch-dynamic-config'] ? redispatchTooltip : cf.messages.permissionMsg">
              <button mat-raised-button color="primary" type="button" class="redispatch-button"
                [attr.aria-label]="redispatchTooltip"
                [disabled]="!authService.permissions['redispatch-dynamic-config'] || dynamicActionLoadingJobId === element.jobId || !isDynamicTriggerAllowed(element.status, element.conclusion)"
                (click)="triggerDynamicAction(element); $event.stopPropagation()">
                <mat-spinner *ngIf="dynamicActionLoadingJobId === element.jobId" [diameter]="16"></mat-spinner>
                <span *ngIf="dynamicActionLoadingJobId !== element.jobId" class="redispatch-label">Redispatch</span>
                <mat-icon *ngIf="dynamicActionLoadingJobId !== element.jobId" class="redispatch-icon">autorenew</mat-icon>
              </button>
            </span>
          </div>

          <!-- event column -->
          <div *ngSwitchCase="'event'" [matTooltip]="element?.event || 'N/A'">
            {{element?.event || 'N/A'}}
          </div>

          <!-- triggered by column -->
          <div *ngSwitchCase="'triggeredBy'" [matTooltip]="element.triggeredBy">
            <app-profile [userId]="element.triggeredBy" [isAPICall]="tourGuideService.isStartTour ? false : true"
              [style]="{width:'127px'}"></app-profile>
          </div>

          <!-- Reason for queue column -->
          <div *ngSwitchCase="'reasonForQue'" [matTooltip]="element.reasonForQue" class="reasonForQue">
            {{element.reasonForQue}}
          </div>

          <!-- abort button -->
          <div *ngSwitchCase="'jobId'"
            [matTooltipDisabled]="!authService.permissions['abort-wf-queue'] ? false : isAbortAllowed(element.status)"
            [id]="tourId.wfQueueMgr.wfQueTable.action.id"
            [ngClass]="{'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['abort-wf-queue'] || !isAbortAllowed(element.status) }"
            matTooltip="{{!authService.permissions['abort-wf-queue'] ? cf.messages.permissionMsg: isAbortAllowed(element.status) ? abortNotAllowed :abortNotAllowed}}">
            <button
              [disabled]="!tourGuideService.isStartTour && !authService.permissions['abort-wf-queue'] || !isAbortAllowed(element.status)"
              mat-raised-button color="primary" (click)="onAbort(element)">
              Abort
            </button>
          </div>

          <!-- Queued time column -->
          <div *ngSwitchCase="'queueTime'">
            <app-duration-show *ngIf="element.status ==='queued'" [timeInSec]="element.queueTime"></app-duration-show>
            <div *ngIf="element.status ==='inprogress'">{{getDuration(element.queueTime)}}</div>
          </div>

          <!-- priority column -->
          <div *ngSwitchCase="'priority'" [id]="tourId.wfQueueMgr.wfQueTable.priority.id">
            <div *ngIf="element.status == 'inprogress'; else inprogress;"
              [ngClass]="{'disabled-cursor': !tourGuideService.isStartTour && !authService.permissions['set-job-priority']}"
              matTooltip="{{authService.permissions['set-job-priority'] ? '' : cf.messages.permissionMsg}}">
              <div [appStatus]="priorityClass(element.priority)" matRipple appElevation
                [ngClass]="{'disabled': !tourGuideService.isStartTour && !authService.permissions['set-job-priority'] }"
                (click)="changePriority(element, priority_block)" #priority_block [looks]="'priority'">
                {{element.priority}}
              </div>
            </div>
            <ng-template #inprogress>
              <div [appStatus]="priorityClass(element.priority)" [width]="'56px'">{{element.priority }}</div>
            </ng-template>
          </div>

          <!--Start time column-->
          <div *ngSwitchCase="'startTime'" [matTooltip]="element[column.key]">
            {{element[column.key] | date}}
          </div>

          <div *ngSwitchCase="'refresh'"></div>

          <!-- normal column -->
          <div *ngSwitchDefault>{{element[column.key]}}
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colMgr.keys"></tr>
    <tr mat-row class="example-element-row" *matRowDef="let row; columns: colMgr.keys;"></tr>
  </table>

  <!-- Mat paginator -->
  <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="hasCustomColumns ? pageIndex : currentPage" showFirstLastButtons
    (page)="onPageChange($event)"></mat-paginator>
</div>